import { useEffect, useState } from "react";
import { ProgressSpinner } from 'primereact/progressspinner';
import DataTableView from "./dataTable";
import { Submission, Requirement, ECIs, POs, Margin } from "./DashboardModel";
import { getCompanyECIs, getCompanyMargins, getCompanyPOs, getCompanyRequirments, getCompanySubmissions } from "./CompanyData";
import { IPermissionProps } from "../../models/Login";


export const Company = (permissions : IPermissionProps) => {
    const [CompanyRequirements, setCompanyRequirements] = useState<Array<Requirement>>([]);
    const [CompanySubmissions, setCompanySubmissions] = useState<Array<Submission>>([]);
    const [CompanyECI, setCompanyECI] = useState<Array<ECIs>>([]);
    const [CompanyPO, setCompanyPO] = useState<Array<POs>>([]);
    const [CompanyMargim, setCompanyMargin] = useState<Array<Margin>>([]);

    useEffect(() => {
        const getCompanyData = async () => {

            const RespCompanyReq = await getCompanyRequirments();
            const RespCompanySub = await getCompanySubmissions();
            const RespCompanyEci = await getCompanyECIs();
            const RespCompanyPo = await getCompanyPOs();
            const RespCompanyMargin = await getCompanyMargins();

            setCompanyRequirements(RespCompanyReq);
            setCompanySubmissions(RespCompanySub);
            setCompanyECI(RespCompanyEci);
            setCompanyPO(RespCompanyPo);
            setCompanyMargin(RespCompanyMargin);
        }
        getCompanyData();

    }, []);

    return (
        permissions.is_View ? <div>
            {CompanyRequirements.length > 0 && CompanySubmissions.length > 0 && <DataTableView ReqData={CompanyRequirements} SubData={CompanySubmissions} ECIData={[]} POData={[]} MarginData={[]} which={"ReqSub"} tabOf={"Company"} />}
            {CompanyRequirements.length === 0 && CompanySubmissions.length === 0 && <ProgressSpinner className="m-auto left-50 mt-8" />}
            {CompanyRequirements.length > 0 && CompanySubmissions.length > 0 && <DataTableView ReqData={[]} SubData={[]} ECIData={CompanyECI} POData={CompanyPO} MarginData={[]} which={"EciPo"} tabOf={"Company"} />}
            {CompanyRequirements.length > 0 && CompanySubmissions.length > 0 && <DataTableView ReqData={[]} SubData={[]} ECIData={[]} POData={[]} MarginData={CompanyMargim} which={"Margin"} tabOf={"Company"} />}
        </div> : <></>
    )
}



